import React, { useEffect } from "react";
import { HiChartBarSquare } from "react-icons/hi2";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useState } from "react";
import apiClient from "../api/apiClient";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { LineChart, Line } from "recharts";
import { SelectOption } from "../mui";
import { formatPlnAmount, getPlnEarnings } from "../utils/currencyUtils";
import RecentSalesList from "../components/RecentSalesList";

const today = () => dayjs().endOf("day").toDate();

const PAGE_TITLE_STYLE = { color: "#000000e6" };

const SECTION_TITLE_CLASS = "fw-bold mb-3 mb-md-4";

const PANEL_STYLE = {
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: "24px",
  boxShadow: "0 2px 8px rgba(99, 99, 99, 0.2)",
};

const STAT_CARD_STYLE = {
  flex: "1 1 280px",
  maxWidth: "100%",
  minHeight: "120px",
};

const DashboardAdmin = () => {
  const [saleItems, setSaleItems] = useState([]);
  const [chartdata, setchartdata] = useState([]);
  const [chartStatsData, setChartStatsData] = useState(null);

  const getDefaultDatesForRange = (r) => {
    const now = dayjs();
    if (r === "weekly") {
      return {
        start: now.subtract(6, "day").toDate(),
        end: now.toDate(),
      };
    }
    if (r === "monthly") {
      return {
        start: now.subtract(30, "day").toDate(),
        end: now.toDate(),
      };
    }
    if (r === "yearly") {
      return {
        start: now.startOf("year").toDate(),
        end: now.toDate(),
      };
    }
    return null;
  };

  const [startDate, setStartDate] = useState(() =>
    dayjs().subtract(6, "day").toDate()
  );
  const [endDate, setEndDate] = useState(() => dayjs().toDate());
  const [range, setRange] = useState("weekly");
  const [modelType, setModelType] = useState("mockups");

  const fetch = async () => {
    const result = await apiClient.get("/sales/?data=r");
    if (result.ok) setSaleItems(result.data.results);
  };
  const fetchstats = async () => {
    const result = await apiClient.get("/admin-stats/");
    if (result.ok) setchartdata(result.data);
  };

  const fetchChartstats = async () => {
    const result = await apiClient.get(
      `/stats/chart-stats/?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}&range=${range}&modelType=${modelType}`
    );
    if (result.ok) setChartStatsData(result.data.data);
  };
  useEffect(() => {
    fetch();
    fetchstats();
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchChartstats();
    }
  }, [range, startDate, endDate, modelType]);

  const dropdownData = [
    { id: "users", name: "👤 Users" },
    { id: "mockups", name: "🎨 Mockups" },
    { id: "bundles", name: "📦 Bundles" },
  ];

  const handleStartDateChange = (date) => {
    if (!date) return;
    const picked = dayjs(date).isAfter(dayjs(), "day") ? dayjs().toDate() : date;
    setStartDate(picked);
    if (endDate && dayjs(endDate).isBefore(dayjs(picked), "day")) {
      setEndDate(picked);
    }
  };

  const handleEndDateChange = (date) => {
    if (!date) return;
    let picked = dayjs(date).isAfter(dayjs(), "day") ? dayjs().toDate() : date;
    if (startDate && dayjs(picked).isBefore(dayjs(startDate), "day")) {
      picked = startDate;
    }
    setEndDate(picked);
  };

  const handleYearChange = (date) => {
    if (!date) return;
    const selected = dayjs(date);
    const now = dayjs();
    const year = selected.year() > now.year() ? now.year() : selected.year();
    const start = dayjs().year(year).startOf("year").toDate();
    const yearEnd = dayjs().year(year).endOf("year");
    const end = yearEnd.isAfter(now) ? now.toDate() : yearEnd.toDate();
    setStartDate(start);
    setEndDate(end);
  };

  const rangeButtonStyle = (r) => ({
    height: "42px",
    backgroundColor: range === r ? "#954001" : "#fff",
    color: range === r ? "#fff" : "#333",
    border: `1px solid ${range === r ? "#954001" : "#ced4da"}`,
    fontWeight: range === r ? 600 : 400,
  });

  return (
    <>
      <div className="container py-3 px-3 px-md-4">
        <h2 className="mb-4" style={PAGE_TITLE_STYLE}>
          Dashboard
        </h2>

        <section className="mb-4">
          <div className="d-flex flex-wrap gap-3 gap-md-4">
            <div
              className="p-4 shadow d-flex gap-3 align-items-center rounded-3 bg-white"
              style={STAT_CARD_STYLE}
            >
              <div className="admin-dashboard__pln-icon p-2 shadow-sm rounded-3 border flex-shrink-0">
                <span className="admin-dashboard__pln-glyph" aria-hidden="true">
                  zł
                </span>
              </div>
              <div>
                <h4 className="fw-bold mb-1">Total Earnings</h4>
                <p className="m-0 fs-5">
                  {formatPlnAmount(getPlnEarnings(chartdata))}
                </p>
              </div>
            </div>
            <div
              className="p-4 shadow d-flex gap-3 align-items-center rounded-3 bg-white"
              style={STAT_CARD_STYLE}
            >
              <div className="p-2 shadow-sm rounded-3 border flex-shrink-0 text-primary">
                <HiChartBarSquare size={32} />
              </div>
              <div>
                <h4 className="fw-bold mb-1">Active Listings</h4>
                <p className="m-0 fs-5">
                  {chartdata?.total_listing ?? "—"}
                </p>
              </div>
            </div>
          </div>
        </section>
            {/* <section className="my-5 overflow-x-auto ">
              <h3>Marketing Performance</h3>
              <div
                className="px-4  pt-4 pb-2 shadow-lg rounded-3"
                style={{ width: "935px" }}
              >
                <AreaChart
                  width={900}
                  height={320}
                  data={chartdata?.monthly_earnings}
                  syncId="areaId"
                  margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="month" />
                  <YAxis />
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="monthly_earnings"
                    stroke="#3780FD"
                    fill="#D1E1FE"
                  />
                </AreaChart>
              </div>
            </section> */}
        <section className="mb-4 text-black" style={PANEL_STYLE}>
          <h3 className={SECTION_TITLE_CLASS} style={PAGE_TITLE_STYLE}>
            Statistics
          </h3>
          <div className="d-flex flex-wrap align-items-end gap-3 gap-md-4 mb-4">
            <div className="d-flex flex-wrap gap-2">
              {["weekly", "monthly", "yearly"].map((r) => (
                <button
                  key={r}
                  onClick={() => {
                    setRange(r);
                    const defaults = getDefaultDatesForRange(r);
                    if (defaults) {
                      setStartDate(defaults.start);
                      setEndDate(defaults.end);
                    }
                  }}
                  type="button"
                  style={rangeButtonStyle(r)}
                  className="btn rounded-pill px-4 py-2 text-capitalize shadow-sm"
                  aria-pressed={range === r}
                >
                  {r}
                </button>
              ))}
            </div>

            {range !== "yearly" && (
              <>
                <div style={{ minWidth: "180px" }}>
                  <label
                    htmlFor="admin-stats-start-date"
                    className="form-label mb-1 small fw-semibold d-block"
                  >
                    Start Date
                  </label>
                  <DatePicker
                    id="admin-stats-start-date"
                    selected={startDate}
                    onChange={handleStartDateChange}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Select start date"
                    className="form-control"
                    dateFormat="MMM d, yyyy"
                    maxDate={
                      endDate && dayjs(endDate).isBefore(dayjs(), "day")
                        ? endDate
                        : today()
                    }
                  />
                </div>
                <div style={{ minWidth: "180px" }}>
                  <label
                    htmlFor="admin-stats-end-date"
                    className="form-label mb-1 small fw-semibold d-block"
                  >
                    End Date
                  </label>
                  <DatePicker
                    id="admin-stats-end-date"
                    selected={endDate}
                    onChange={handleEndDateChange}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    maxDate={today()}
                    placeholderText="Select end date"
                    className="form-control"
                    dateFormat="MMM d, yyyy"
                  />
                </div>
              </>
            )}

            {range === "yearly" && (
              <div style={{ minWidth: "180px" }}>
                <label
                  htmlFor="admin-stats-year"
                  className="form-label mb-1 small fw-semibold d-block"
                >
                  Year
                </label>
                <DatePicker
                  id="admin-stats-year"
                  selected={startDate}
                  onChange={handleYearChange}
                  showYearPicker
                  dateFormat="yyyy"
                  placeholderText="Select year"
                  className="form-control"
                  maxDate={today()}
                />
              </div>
            )}

            <div style={{ minWidth: "220px", flex: "1 1 220px", maxWidth: "280px" }}>
              <SelectOption
                name="modelType"
                label="Select Model Type"
                value={modelType}
                onChange={(e) => setModelType(e.target.value)}
                data={dropdownData}
                fieldNames={{ value: "id", name: "name" }}
                size="small"
                style={{ width: "100%" }}
                selectCss={{
                  borderRadius: "16px",
                  background: "#fff",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  paddingX: 1,
                }}
                labelStyle={{ fontSize: "14px", fontWeight: 500 }}
              />
            </div>
          </div>

          {chartStatsData && (
            <div style={{ width: "100%", height: 320 }}>
              <ResponsiveContainer width="100%" height="100%">
                {range !== "yearly" ? (
                  <LineChart data={chartStatsData}>
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                    <XAxis
                      dataKey="date"
                      tickFormatter={(str) => dayjs(str).format("MM-DD")}
                    />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="count" stroke="#8884d8" />
                  </LineChart>
                ) : (
                  <LineChart data={chartStatsData}>
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="count" stroke="#8884d8" />
                  </LineChart>
                )}
              </ResponsiveContainer>
            </div>
          )}
        </section>

        <section className="mb-4" style={PANEL_STYLE}>
          <h3 className={SECTION_TITLE_CLASS} style={PAGE_TITLE_STYLE}>
            Recent Sales
          </h3>
          <RecentSalesList
            items={saleItems}
            emptyMessage="Sales is empty."
          />
        </section>
      </div>
    </>
  );
};

export default DashboardAdmin;
